import client from "./client";

export interface MyProfileAddress {
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
}

export interface MyEmergencyContact {
  name: string;
  relationship?: string | null;
  phone?: string | null;
  email?: string | null;
}

export interface MyProfile {
  // Editable
  phone: string | null;
  personal_email: string | null;
  address_json: MyProfileAddress | null;
  emergency_contacts_json: MyEmergencyContact[] | null;
  timezone: string | null;
  locale: string | null;
  pronouns: string | null;
  preferred_name: string | null;
  // Read-only
  id: string;
  first_name: string;
  last_name: string;
  work_email: string | null;
  title: string;
  department_id: string | null;
  department_name: string | null;
  manager_id: string | null;
  manager_name: string | null;
  hire_date: string;
  employment_type: string;
  status: string;
  avatar_url: string | null;
  profile_reviewed_at: string | null;
}

export interface MyProfileUpdateInput {
  phone?: string | null;
  personal_email?: string | null;
  address_json?: MyProfileAddress | null;
  emergency_contacts_json?: MyEmergencyContact[] | null;
  timezone?: string | null;
  locale?: string | null;
  pronouns?: string | null;
  preferred_name?: string | null;
}

export interface ProfileCompleteness {
  percentage: number;
  missing: string[];
  detail: Record<string, { has: boolean; weight: number; label: string }>;
}

export interface NotificationPreferences {
  leave_updates: boolean;
  document_assignments: boolean;
  announcements: boolean;
  agent_notifications: boolean;
  push_notifications: boolean;
}

export async function getMyProfile(): Promise<MyProfile> {
  const { data } = await client.get("/my/profile");
  return data;
}

export async function updateMyProfile(
  input: MyProfileUpdateInput,
): Promise<MyProfile> {
  const { data } = await client.put("/my/profile", input);
  return data;
}

export async function markProfileReviewed(): Promise<{ profile_reviewed_at: string }> {
  const { data } = await client.post("/my/profile/review");
  return data;
}

export async function getProfileCompleteness(): Promise<ProfileCompleteness> {
  const { data } = await client.get("/my/profile/completeness");
  return data;
}

export async function uploadMyAvatar(file: File): Promise<{ avatar_url: string }> {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await client.post("/my/avatar", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function getNotificationPreferences(): Promise<NotificationPreferences> {
  const { data } = await client.get("/my/notification-preferences");
  return data;
}

export async function setNotificationPreferences(
  prefs: NotificationPreferences,
): Promise<NotificationPreferences> {
  const { data } = await client.put("/my/notification-preferences", prefs);
  return data;
}
